import { HttpMethod } from "../types";

export const {
  ENV_API_BASE_URL,
  ENV_API_KEY,
  ENV_AUTH0_CLIENT_DOMAIN,
  ENV_AUTH0_CLIENT_ID
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
} = dmenv;

export type Headers = Record<string, string>;

export const fetchToApi = (url: string, method: HttpMethod, payload: any, token?: string, headers?: Headers) => {
  const baseUrl = ENV_API_BASE_URL ?? "";
  const apiKey = ENV_API_KEY ?? "";
  return fetch(`${baseUrl}${url}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      "api-key": apiKey,
      Authorization: token ? `Bearer ${token}` : "",
      ...headers
    },
    body: JSON.stringify(payload)
  });
};
